<template>
  <v-card>
    <v-tabs
      v-model="tab"
      bg-color="secondary"
      color="white"
      :disabled="requestingApi"
    >
      <v-tooltip location="top" text="Configurações da notícia">
        <template v-slot:activator="{ props }">
          <v-tab :value="1" v-bind="props">
            <v-icon>mdi-cog</v-icon> Notícia
          </v-tab>
        </template>
      </v-tooltip>
      <v-tooltip location="top" text="Destinatários" v-if="value.id">
        <template v-slot:activator="{ props }">
          <v-tab :value="2" v-bind="props">
            <v-icon>mdi-account-multiple-plus</v-icon> Destinatários
          </v-tab>
        </template>
      </v-tooltip>
      <v-tooltip location="top" text="Anexos da notícia" v-if="value.id">
        <template v-slot:activator="{ props }">
          <v-tab :value="4" v-bind="props">
            <v-icon>mdi-paperclip</v-icon> Arquivos anexados
          </v-tab>
        </template>
      </v-tooltip>
    </v-tabs>

    <v-card-text>
      <v-window v-model="tab">
        <v-window-item :value="1">
          <v-form :submit="submitUpdate">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Nome/Assunto"
                  v-model="value.name"
                  :rules="rules.required"
                  :disabled="requestingApi"
                  :readonly="
                    value.status == 1 || value.status == 0 ? false : true
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="value.destinations"
                  :items="[
                    { destination: 'EMAIL' },
                    { destination: 'WHATSAPP' },
                  ]"
                  :disabled="requestingApi"
                  hide-details
                  :custom-filter="customFilter"
                  label="Destinos"
                  :return-object="true"
                  item-title="destination"
                  multiple
                  chips
                  :clearable="
                    value.status == 1 || value.status == 0 ? true : false
                  "
                  :required="required"
                  :rules="rules.required"
                  :readonly="
                    value.status == 1 || value.status == 0 ? false : true
                  "
                >
                  <template v-slot:no-data>
                    <div class="px-4">Digite sua busca</div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-row class="ma-0 pa-0">
                  <v-col cols="8" class="ma-0 pa-0">
                    <v-text-field
                      type="date"
                      label="Data de envio"
                      clearable
                      v-model="schedule_date"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="4" class="ma-0 pa-0">
                    <v-text-field
                      type="text"
                      label="hh:mm"
                      v-model="schedule_time"
                      v-mask="'##:##'"
                      clearable
                      append-inner-icon="mdi-clock"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="Mensagem"
                  v-model="value.message"
                  :rules="rules.required"
                  density="compact"
                  :disabled="requestingApi"
                  :readonly="
                    value.status == 1 || value.status == 0 ? false : true
                  "
                ></v-textarea>
              </v-col>
              <v-col cols="6" class="text-left">
                <v-btn
                  color="blue"
                  @click="startDelivery()"
                  v-if="value.id && (value.status == 1 || value.status == 0)"
                  :disabled="requestingApi"
                  :loading="startingDelivery"
                >
                  <v-icon class="mr-2">mdi-share</v-icon> Enviar agora</v-btn
                >
              </v-col>
              <v-col
                cols="6"
                class="text-right"
                v-if="value.status == 1 || value.status == 0"
              >
                <v-btn color="success" type="submit" :disabled="requestingApi"
                  ><v-icon class="mr-2">mdi-content-save</v-icon> Salvar</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-window-item>
        <v-window-item :value="2">
          <FormNewsReceivers
            :user="user"
            :newsId="value.id"
            v-model="receivers"
            @loadReceivers="loadReceivers"
            @updated="loadReceivers"
            :loading="requestingApi"
            :readonly="value.status == 1 || value.status == 0 ? false : true"
          />
        </v-window-item>
        <v-window-item :value="4">
          <v-row>
            <v-col cols="12" v-if="requestingApi">
              <h3>Carregando ...</h3>
            </v-col>
            <v-col cols="12" v-if="value.status == 1 || value.status == 0">
              <p class="text-overline">Adicionar arquivo</p>
              <UploadNewsAttachment
                :newsId="value.id"
                @uploaded="fileUploaded"
              />
            </v-col>
            <v-col
              cols="12"
              v-if="newsAttachments && newsAttachments.length > 0"
            >
              <v-list lines="one" density="compact">
                <div
                  v-for="(newsAttachment, ixfl) in newsAttachments"
                  :key="ixfl"
                >
                  <v-list-item :title="newsAttachment?.file?.original_name">
                    <template
                      v-slot:append
                      v-if="value.status == 1 || value.status == 0"
                    >
                      <v-btn
                        :disabled="requestingApi"
                        color="red"
                        variant="text"
                        icon
                        size="medium"
                        class="ml-2"
                        density="compact"
                        @click="deleteFile(newsAttachment, ixfl)"
                        ><v-icon>mdi-delete</v-icon></v-btn
                      >
                    </template>
                    <template v-slot:prepend>
                      <v-btn
                        :disabled="requestingApi"
                        color="primary"
                        variant="text"
                        icon
                        size="medium"
                        class="mr-2"
                        density="compact"
                        @click="downloadFile(newsAttachment.file)"
                        ><v-icon>mdi-download</v-icon></v-btn
                      >
                    </template>
                  </v-list-item>
                  <v-divider></v-divider>
                </div>
              </v-list>
            </v-col>
          </v-row>
        </v-window-item>
      </v-window>
    </v-card-text>
  </v-card>
</template>
<script>
import AutocompleteSelectCreateLegalPerson from "./AutocompleteSelectCreateLegalPerson.vue";
import FormNewsReceivers from "./FormNewsReceivers.vue";
import ListFromTo from "./ListFromTo.vue";
import UploadNewsAttachment from "./UploadNewsAttachment.vue";
import api from '@/services'
export default {
  components: {
    ListFromTo,
    FormNewsReceivers,
    UploadNewsAttachment,
    AutocompleteSelectCreateLegalPerson,
  },
  props: {
    user: Object,
    modelValue: Object,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      requestingApi: false,
      startingDelivery: false,
      tab: 1,
      receivers: [],
      newsAttachments: [],
      searchText: null,
      schedule_date: null,
      schedule_time: null,
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
      },
    };
  },
  created() {
    var vm = this;
    if (!vm.modelValue?.id) {
      vm.value = vm.generateEmpty();
    } else {
      if (vm.value?.schedule) {
        let _date = vm.$moment.parseZone(vm.value.schedule);
        vm.schedule_date = _date.format('YYYY-MM-DD')
        vm.schedule_time = _date.format('HH:mm')
      }
    }
  },
  mounted() {},
  methods: {
    submitUpdate() {
      var vm = this;
      if (vm.schedule_date || vm.schedule_time) {
        if (vm.schedule_date && vm.schedule_time) {
          let _date = vm.$moment.parseZone(`${vm.schedule_date} ${vm.schedule_time}`);
          _date = new Date(_date.toISOString().replace('Z', '-03:00'))
          vm.value.schedule = _date.toISOString()
          console.debug(_date)
        } else {
          vm.$notify({
            type: "warn",
            text: "Para definir uma data de envio é obrigatório informar o horário e a data. Caso contrário, não informe nenhum dos dois campos.",
          });
          return;
        }
      } else {
        vm.value.schedule = null
      }
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.news[vm.value?.id ? "update" : "create"](vm.value)
          .then((result) => {
            if (vm.value.id) {
              vm.$emit("updated", result);
              vm.$notify({
                type: "success",
                text: "Notícia atualizada com sucesso",
              });
            } else {
              vm.value = result;
              vm.$emit("created", result);
              vm.$notify({
                type: "success",
                text: "Notícia criada com sucesso",
              });
            }
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    startDelivery() {
      var vm = this;
      vm.requestingApi = true;
      vm.startingDelivery = true;
      return new Promise((resolve, reject) => {
        api.news
          .startDelivery(vm.value.id)
          .then((result) => {
            vm.value.status = result.status;
            vm.$emit("updated", result);
            vm.$notify({
              type: "success",
              text: "Enviado com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
            vm.startingDelivery = false;
          });
      });
    },
    loadReceivers() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        const urlParams = [`news_id=${vm.value?.id}`];
        api.newsReceiver
          .list(urlParams)
          .then((result) => {
            vm.receivers = (result || []).map((i) => {
              let _color = null;
              switch (i.status) {
                case 0:
                  break;
                case 1:
                  _color = "blue";
                  break;
                case 10:
                  _color = "green";
                  break;
              }
              return {
                ...i.legal_person,
                from_to_color: _color,
              };
            });
            console.debug(vm.receivers);
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    loadNewsAttachments() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.newsAttachment
          .list([`news_id=${vm.value?.id}`])
          .then((result) => {
            console.debug(result);
            vm.newsAttachments = result || [];
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    fileUploaded(newsAttachment) {
      var vm = this;
      vm.newsAttachments.push(newsAttachment);
    },
    downloadFile(file) {
      window.open(file.path, "_blank");
    },
    deleteFile(newsAttachment, index) {
      var vm = this;
      let _confirm = confirm(
        `Deseja realmente escluir o arquivo ${newsAttachment.file.original_name}`
      );
      if (_confirm) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.newsAttachment
            .delete(newsAttachment.news_id, newsAttachment.id)
            .then((result) => {
              vm.newsAttachments.splice(index, 1);
              vm.$notify({
                type: "success",
                text: "Arquivo removido",
              });
              resolve(true);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
              reject(err);
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    generateEmpty() {
      return {
        name: null,
        message: null,
        status: 0,
        schedule: null,
        receivers: [],
      };
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    "value.coordinator"(newVal) {
      if (newVal?.id) {
        this.value.coordinator_id = newVal.id;
      } else {
        this.value.coordinator_id = null;
      }
    },
    tab(newVal) {
      if (newVal == 4) {
        this.loadNewsAttachments();
      }
    },
  },
};
</script>